module.exports = __webpack_public_path__ + "static/media/twitter_x.7d5b32b9.svg";